'use strict';

var dateFns = require('date-fns');
var partsToTimestamp = require('./partsToTimestamp.cjs');

const parseISOTimePartIntervalToTimestampInterval = ({
  datePart,
  timePartInterval,
  timeZone
}) => {
  const start = partsToTimestamp({
    isoDatePart: datePart,
    isoTimePart: timePartInterval.start,
    timeZone
  });
  const end = partsToTimestamp({
    isoDatePart: datePart,
    isoTimePart: timePartInterval.end,
    timeZone
  });
  if (start > end) {
    return { start, end: dateFns.addDays(end, 1).getTime() };
  }
  return { start, end };
};

module.exports = parseISOTimePartIntervalToTimestampInterval;
//# sourceMappingURL=parseISOTimePartIntervalToTimestampInterval.cjs.map
